import { getLang } from '../utils/helpers.js';

// require('../vendor/jquery.validate.min.js');
require('../vendor/select2.min');
require('../utils/forms.js');


var $partnershipForm = $('.js-partnership-form');

$('.js-counter').click(function(){
    var $btn = $(this);
    var $counter = $('.count__number');
    var value = parseInt($btn.data('quantity'));
    var countValue = parseInt($counter.val());

    if (countValue + value > 0) {
        $counter.val(countValue + value);
    }
});

$('.count__number').change(function(e){
    if(parseInt($(this).val()) <= 0) {
        $(this).val(1);
        e.preventDefault();
        return false;
    }
});

$('.js-registration-region').change(function(){
    var codes = $(this).find('option:selected').data('codes').split(',');
    var codesData = [];
    $('.select_region option').remove();
    $.each(codes, function (index, value) {
        var newOption = new Option(value, value, false, false);
        $('select.select_region').append(newOption);
    });
    $('.select_region').trigger('change');
});

var validator = $partnershipForm.validate({
    lang: getLang(),
    debug: false,
    errorClass: 'form-error',
    errorElement: 'span',
    ignore: '',
    rules: {
      model: {
        required: true,
      },
      volume: {
        required: true,
      },
      name: {
        required: true,
      },
      email: {
        required: true,
        email: true,
      },
      phone: {
        required: true,
        phone: true,
        normalizer: function(value){
          return value.replace(/[\s\-\(\)]/g, '');
        },
      },
    },
    errorPlacement: function (error, element) {
        if($(element).is(':radio')) {
            $(element).parent().parent().prev().append(error);
        } else {
            $(element).prev().append(error);
        }
    },
    highlight: function(element) {
        if($(element).is(':radio')) {
            $(element).parent().parent().prev().addClass('_error');
        } else {
            $(element).addClass('_error');
            $(element).prev().addClass('_error');
        }
        
        
    },
    unhighlight: function(element) {
        if($(element).is(':radio')) {
            $(element).parent().parent().prev().removeClass('_error');
        } else {
            $(element).removeClass('_error');
            $(element).prev().removeClass('_error');
        }
    }
});


var taskStep = 0;

function changeStep(step) {
    $('.stepper__step').removeClass('stepper__step_active');
    $('.stepper__step').eq(step).addClass('stepper__step_active');
    $('.stepper__body').fadeOut(300).eq(step).delay(300).fadeIn(300, function() {
        // $(window).scrollTop();
        $('html, body').animate(
            {
                scrollTop: $('.stepper__body').eq(step).offset().top - 100
            }, 300
        );
    });
}

$('.js-partnership-step-next').click(function(){
    $('.partners__form-header').show();
    if (taskStep == 0) {
        var modelValid = validator.element('#model');
        var volumeValid = validator.element('#volume');
        if(modelValid && volumeValid) {
            taskStep++;
            changeStep(taskStep);
        } else {
            if(!modelValid) {
                $('html, body').animate(
                    {
                        scrollTop: $('#model').offset().top - 100
                    }, 300
                );
            } else if(!volumeValid) {
                $('html, body').animate(
                    {
                        scrollTop: $('#volume').offset().top - 100
                    }, 300
                );
            }
        }
    } else if(taskStep == 1) {
        $partnershipForm.submit();
        
    } else if(taskStep == 2) {
        taskStep = 0;
        changeStep(taskStep);
    }
});

$('.js-partnership-step-prev').click(function(){
    if(taskStep > 0) {
        taskStep--;
        changeStep(taskStep);
    }
});


$partnershipForm.submit(function(){
    if(validator.valid()) {
        $.post(
            $partnershipForm.attr('action'),
            $partnershipForm.serialize(),
            function(data) {
                if(data.error != true) {
                    $('.partners__form-header').hide();
                    $partnershipForm[0].reset();
                    validator.reset();
                    taskStep++;
                    changeStep(taskStep);
                }
            }
        )
    }
    return false;
});


// WEBPACK FOOTER //
// ./js/pages/partnership.js